import { render, staticRenderFns } from "./hyhddetail.vue?vue&type=template&id=37de3525&scoped=true&"
import script from "./hyhddetail.vue?vue&type=script&lang=js&"
export * from "./hyhddetail.vue?vue&type=script&lang=js&"
import style0 from "./hyhddetail.vue?vue&type=style&index=0&id=37de3525&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37de3525",
  null
  
)

export default component.exports